/**
 * Warm the same dynamic import() promises as App.tsx lazy routes so navigation
 * feels instant after hover. Failures are ignored (offline, adblock, etc.).
 */
const routeImporters: Record<string, () => Promise<unknown>> = {
  '/dashboard': () => import('@/pages/DashboardPage'),
  '/president-analytics': () => import('@/pages/PresidentDashboardPage'),
  '/shifts': () => import('@/pages/ShiftsPage'),
  '/messages': () => import('@/features/messages/MessagesPage'),
  '/tasks': () => import('@/pages/TasksPage'),
  '/yazi-isleri': () => import('@/pages/YaziIsleriPage'),
  '/analysis': () => import('@/pages/AnalysisPage'),
  '/route-optimization': () => import('@/pages/RouteOptimizationPage'),
  '/dispatch': () => import('@/pages/DispatchPage'),
  '/vehicles': () => import('@/pages/VehiclesPage'),
  '/warehouse': () => import('@/pages/WarehousePage'),
  '/users': () => import('@/pages/UserManagementPage'),
  '/document-archive': () => import('@/pages/DocumentArchivePage'),
  '/it-tickets': () => import('@/pages/ItTicketsPage'),
  '/beyaz-masa-tickets': () => import('@/pages/BeyazMasaTicketsPage'),
  '/beyaz-masa/dashboard': () => import('@/pages/BeyazMasaDashboard'),
  '/beyaz-masa/stats': () => import('@/pages/BeyazMasaStatsPage'),
  '/classification-feedback': () => import('@/pages/ClassificationFeedbackPage'),
  '/settings': () => import('@/pages/SettingsPage'),
}

export function prefetchRoute(pathname: string): void {
  const run = routeImporters[pathname]
  if (!run) return
  void run().catch(() => {})
}
